import { Component } from "react";
import {
    createStyles,
    Paper,
    Typography,
    WithStyles,
    withStyles
} from "@material-ui/core";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IAppState } from "../../store";
import * as UserStore from "../../store/UserStore";

type LogoutProps = UserStore.IUserStoreState &
    typeof UserStore.actionCreators &
    WithStyles<typeof styles>;
const styles = () =>
    createStyles({
        paper: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            height: "900px",
            textAlign: "center",
            alignContent: "center",
            justifyContent: "center",
            backgroundColor: "#231F20"
        }
    });

class Logout extends Component<LogoutProps> {
    public componentDidMount() {
        this.props.logoutUser();
    }

    public render() {
        const classes = this.props.classes;
        return (
            <Paper className={classes.paper} elevation={2}>
                <Typography>Logging out...</Typography>
            </Paper>
        );
    }
}

export default withStyles(styles)(
    connect(
        (state: IAppState) => state.userStoreState,
        (dispatch) => bindActionCreators(UserStore.actionCreators, dispatch)
    )(Logout)
);
